/*******************************************************************************
 * ALMA - Atacama Large Millimeter Array
 * Copyright (c) UKATC - UK Astronomy Technology Centre, Science and Technology Facilities Council, 2011
 * (in the framework of the ALMA collaboration).
 * All rights reserved.
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA 02111-1307  USA
 *******************************************************************************/
import React, { Component, PropTypes } from 'react';

export default class OctileOption extends Component {
  render() {
    const { value, onChange } = this.props;
    return (
      <div className="form-group">
        <label className="col-sm-4 control-label"> Water Vapour </label>
        <div className="col-sm-8 last">
          <label className="form-check-inline col-sm-4">
            <input
              type="radio"
              value="Automatic"
              checked={value === 'Automatic'}
              onChange={e => onChange('Automatic')}
            />{' '}
            Automatic Choice
          </label>
          <label className="form-check-inline last">
            <input
              type="radio"
              value="Manual"
              checked={value === 'Manual'}
              onChange={e => onChange('Manual')}
            />{' '}
            Manual Choice
          </label>
        </div>
      </div>
    );
  }
}

OctileOption.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
